/* Only controls the responsive filter disclosure; catalog requests remain native. */
if (!customElements.get('glomatek-filter-panel')) {
  customElements.define('glomatek-filter-panel', class extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('details');
      if (!this.panel) return;
      this.viewport = window.matchMedia('(min-width: 1024px)');
      this.onViewportChange = () => { this.panel.open = this.viewport.matches; };
      this.onViewportChange();
      this.viewport.addEventListener('change', this.onViewportChange);
    }
    disconnectedCallback() {
      if (this.viewport) this.viewport.removeEventListener('change', this.onViewportChange);
    }
  });
}
